import { useState, useEffect } from "react";
import { ArrowRight, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const API_URL = "";

export const LatestArticles = () => {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_URL}/api/blog/articles?limit=3`)
      .then((r) => r.json())
      .then((data) => setArticles(Array.isArray(data) ? data.slice(0, 3) : []))
      .catch(() => setArticles([]));
  }, []);

  if (articles.length === 0) return null;

  return (
    <section className="py-20 sm:py-28 bg-white" data-testid="latest-articles-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-14">
          <div className="max-w-xl">
            <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">
              Dal Nostro Blog
            </span>
            <h2
              className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="latest-articles-title"
            >
              Notizie e guide sull'energia verde
            </h2>
            <p className="mt-4 text-slate-500 text-base sm:text-lg">
              Resta aggiornato sulle novita del mondo fotovoltaico e dell'energia rinnovabile.
            </p>
          </div>
          <button
            onClick={() => navigate("/blog")}
            className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-600 hover:text-emerald-700 whitespace-nowrap self-start sm:self-auto"
            data-testid="view-all-articles-link"
          >
            Leggi Tutti gli Articoli
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article, i) => (
            <button
              key={article.slug || i}
              onClick={() => navigate(`/blog/${article.slug}`)}
              className="group text-left bg-white rounded-2xl border border-slate-100 overflow-hidden hover:border-emerald-400/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer"
              data-testid={`latest-article-${i}`}
            >
              {article.cover_image_url && (
                <div className="h-48 overflow-hidden">
                  <img
                    src={
                      article.cover_image_url.startsWith("http")
                        ? article.cover_image_url
                        : `${API_URL}${article.cover_image_url}`
                    }
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  {article.category && (
                    <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2.5 py-1 rounded-full">
                      {article.category}
                    </span>
                  )}
                  {article.created_at && (
                    <span className="flex items-center gap-1 text-xs text-slate-400">
                      <Clock className="w-3 h-3" />
                      {new Date(article.created_at).toLocaleDateString("it-IT", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  )}
                </div>
                <h3
                  className="text-base font-bold text-slate-900 line-clamp-2 mb-2"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {article.title}
                </h3>
                {article.excerpt && (
                  <p className="text-sm text-slate-500 line-clamp-2">{article.excerpt}</p>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
